export default "__VITE_ASSET__DitC07Pf__"